import Template from "core/ts/system/Template";

/**
 * @ignore
 */
export default class ErrorTemplate extends Template {

}